"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgMenu = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M22.92 5.969H1.08C.462 5.969 0 5.5 0 4.984 0 4.47.514 4 1.08 4h21.84c.617 0 1.08.469 1.08.984 0 .516-.514.985-1.08.985zM22.92 12.922H1.08c-.617 0-1.08-.469-1.08-.985 0-.515.514-.984 1.08-.984h21.84c.617 0 1.08.469 1.08.985 0 .515-.514.984-1.08.984zM22.92 19.875H1.08c-.617 0-1.08-.47-1.08-.985s.514-.984 1.08-.984h21.84c.617 0 1.08.469 1.08.984 0 .516-.514.985-1.08.985z" })));
};
exports.default = SvgMenu;
//# sourceMappingURL=Menu.js.map